export const extractionConfig = {
    TIME_TO_EXTRACT_IN_SECONDS: 10,
    MAX_RUN_DURATION_IN_SECONDS: 60 * 7, // 7 minutes

    DEBUG: {
        // Collider visuals
        DRAW_COLLIDER: false
    }
};
